import React, { useState, useEffect, useRef, useContext } from "react";
import { Link } from "react-router-dom";

import { format } from "date-fns";
import socketIOClient from "socket.io-client";
import Picker from "emoji-picker-react";
import { API, CHAT_API } from "../../constants/Api";
import { toast } from "react-toastify";

function ShowingChat() {
  const [projects, setProjects] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [chatOpen, setChatOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  // const { notification, setNotification } = useContext(NotificationData);
  const [socket, setSocket] = useState(null);
  const [clients, setClients] = useState(null);
  const [records, setRecords] = useState([]);
  const [chat, setChat] = useState(null);
  const [selectedChatName, setSelectedChatName] = useState("");
  // const myId = localStorage.getItem("userID");
  const myId = "660bdda23ed917de195011b5";
  const token = localStorage.getItem("token");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [receiverId, setReceiverId] = useState("");
  const [checkActiveChat, setActiveChat] = useState("");
  const scrollableDivRef = useRef(null);
  const [showPicker, setShowPicker] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileRef = useRef(null);

  // my new code start
  const [leads, setLeads] = useState(null);
  const aqdasId = localStorage.getItem("agentId");
  const [aqdasChat, setAqdasChat] = useState(null);
  const [event, setEvent] = useState("");
  const [type, setType] = useState("");
  const [paidByAgentsAqdas, setPaidBuyAgentsAqdas] = useState([]);
  const [receiverIdAqdas, setReceiverIdAqdas] = useState("");
  const [headerImage, setHeaderImage] = useState("");

  useEffect(() => {
    const newSocket = socketIOClient(CHAT_API); // Replace API with your backend URL
    setSocket(newSocket);

    // Store socket ID for the user
    newSocket.on("connect", () => {
      newSocket.emit("storeSocketId", aqdasId);
    });

    // Listen for incoming messages
    newSocket.on("receiveSchedulingTourMessage", (message) => {
      if (message.receiverId === aqdasId) {
        setAqdasChat((prevChat) => [...(prevChat || []), message]);
      }
    });

    // Cleanup on unmount
    return () => {
      newSocket.disconnect();
    };
  }, [aqdasId]);

  useEffect(() => {
    const getPaidTours = async () => {
      try {
        const response = await fetch(
          `${API}/scheduled-tours/getPaid-scheduled-tours`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();
        if (response.ok) {
          setLeads(json.data || []);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
    getPaidTours();
  }, [token]);

  const fetchTourChat = async (leadId, id) => {
    const response2 = await fetch(
      `${API}/chat/userShowingAgent/messages?chatId=${id}&event=${leadId}`
    );
    const json2 = await response2.json();
    if (response2.ok) {
      setAqdasChat(json2.data);
      // setChatOpen(true);
      // setSelectedChatName(houseAddress);
      // setType(type);
      // setEvent(leadId);
      // setActiveChat(leadId);
    }
  };

  const getAqdasChat = async (leadId, houseAddress, user) => {
    // const leadId = "67bec0747b02cb09c09fe6ba";
    setChatOpen(true);
    setSelectedChatName(houseAddress);
    setEvent(leadId);
    setActiveChat(leadId);
    setReceiverIdAqdas(user);

    const response = await fetch(
      `${API}/chat/userShowingAgent/chatIds?event=${leadId}&userId=${aqdasId}`
    );
    const json = await response.json();
    console.log("aqdas offer");
    if (response.ok && json.data.length > 0) {
      console.log(json);
      fetchTourChat(leadId, json.data[0]);
    } else {
      setAqdasChat(null);
    }
  };

  useEffect(() => {
    if (leads && leads.length > 0) {
      scrollableDivRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [chat]);
  // my new code ends

  const handleAttachFile = () => {
    fileRef.current.click();
  };
  const handleImageChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      console.log("Selected File:", selectedFile); // Debugging log
      setFile(selectedFile);
      setMessage(selectedFile.name);
    } else {
      console.log("No file selected"); // Debugging log
    }
  };

  const onEmojiClick = (e) => {
    console.log(e);
    setMessage((prev) => prev + e.emoji);
    setShowPicker(false);
  };
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    const handleMediaQueryChange = (event) => {
      if (event.matches) {
        setIsMobile(true);
      }
    };

    // Initial check
    if (mediaQuery.matches) {
      setIsMobile(true);
    }

    // Add listener
    mediaQuery.addEventListener("change", handleMediaQueryChange);

    // Cleanup listener on component unmount
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, [chatOpen]);

  useEffect(() => {
    if (leads && leads.length > 0) {
      scrollableDivRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [aqdasChat]);

  const handleSend = async () => {
    if (message.trim() !== "" || file) {
      document.getElementById("client-message-input").placeholder =
        "sending...";
      setLoading(true);

      const formData = new FormData();

      formData.append("event", event);
      formData.append("eventModel", "SchedulingTour");
      formData.append("senderId", aqdasId);
      formData.append("senderModel", "agents");
      formData.append("receiverId", receiverIdAqdas);
      formData.append("receiverModel", "User");

      if (file) {
        formData.append("files", file);
        console.log("File appended to FormData:", file); // Debugging log
      } else if (message.trim() !== "") {
        formData.append("message", message);
      }

      try {
        const response = await fetch(`${API}/chat/userShowingAgent/send`, {
          method: "POST",
          body: formData,
        });
        if (response.ok) {
          // socket.emit("sendSchedulingTourMessage", {
          //   event,
          //   eventModel: "SchedulingTour", // Added
          //   senderId: aqdasId,
          //   senderModel: "agents", // Added
          //   receiverId: receiverIdAqdas,
          //   receiverModel: "User", // Added
          //   message: message,
          //   files: file ? [file] : [],
          // });
          // Reset states after successful send
          setFile(null); // Reset file state
          setMessage(""); // Reset message state
          fileRef.current.value = ""; // Clear file input value
          console.log("File sent successfully, state reset."); // Debugging log
        } else {
          setFile(null);
        }
      } catch (error) {
      } finally {
        if (file) {
          // await runProgress();
        }
        setMessage("");

        setFile(null);
        getAqdasChat(event, selectedChatName, receiverIdAqdas);

        document.getElementById("client-message-input").disabled = false;
        setLoading(false);
        document.getElementById("client-message-input").placeholder =
          "Type message...";
      }
    }
  };

  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const createdAtDate = new Date(timestamp);
    const timeDifference = now - createdAtDate;

    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day${days === 1 ? "" : "s"} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    } else {
      return `${seconds} second${seconds === 1 ? "" : "s"} ago`;
    }
  };

  const setFilter = (value) => {
    const result = clients.filter((record) => {
      return record.receiverName.toLowerCase().includes(value.toLowerCase());
    });

    setRecords(result);
  };
  const handleSectionClick = () => {
    setShowPicker(false)
  };
  return (
    <>
      <div className="col-lg-12" onClick={handleSectionClick}>
        {leads && leads.length > 0 ? (
          <>
            <div className="card chat-card chat-app-client">
              <div
                id="plist"
                className={`people-list-client ${
                  chatOpen && isMobile ? "d-none" : ""
                }`}
              >
                {/* <div className="input-group">
      <div className="input-group-prepend">
        <span className="input-group-text">
          <i class="bi bi-search"></i>
        </span>
      </div>
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        onChange={(e) => setFilter(e.target.value)}
      />
    </div> */}
                {/* user list start  */}
                <ul className="list-unstyled chat-list-client mb-0">
                  {leads &&
                    leads.map((lead) => (
                      <li
                        onClick={() => {
                          getAqdasChat(lead._id, lead.houseAddress, lead.user);
                          setHeaderImage(lead.houseImages[0]);
                        }}
                        key={lead._id}
                        className={`clearfix-client mb-3 ${
                          lead._id === checkActiveChat ? "active" : ""
                        }`}
                      >
                        <img
                          // src="https://bootdey.com/img/Content/avatar/avatar2.png"
                          src={lead.houseImages[0]}
                          style={{ objectFit: "cover" }}
                          alt="avatar"
                        />
                        <div className="about">
                          <div className="name">
                            {lead.houseAddress.split(0, 31)}
                          </div>
                          <div className="status">
                            {" "}
                            <i
                              className={`bi bi-chat-dots-fill text-dark d-none"}`}
                            />{" "}
                            &nbsp;
                            {getTimeAgo(lead.createdAt)}{" "}
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
                {/* user list ends  */}
              </div>
              <div
                className={`chat-client ${
                  chatOpen === false && isMobile === true ? "d-none" : ""
                }`}
              >
                {selectedChatName == "" ? (
                  <></>
                ) : (
                  <div className="chat-header-client clearfix-client">
                    <div className="row">
                      <div className="col-12">
                        <a
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#view_info"
                        >
                          <img src={headerImage} alt="avatar" />
                        </a>
                        <div className="chat-about">
                          <h6 className="mb-0 chat-about-aqdas">{selectedChatName}</h6>
                          {/* <small style={{fontSize: "14px!important"}}>Last seen: 2 hours ago</small> */}
                        </div>
                        {chatOpen && isMobile ? (
                          <>
                            <i
                              className="bi bi-x float-right text-white"
                              role="button"
                              onClick={() => setChatOpen(false)}
                            ></i>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="chat-history-client">
                  <ul
                    className="mb-0"
                    style={{ position: "relative" }}
                    ref={scrollableDivRef}
                  >
                    <>
                      {aqdasChat &&
                        aqdasChat.map((data) =>
                          data.senderModel === "agents" ||
                          data.senderModel === "agents" ? (
                            <li className="clearfix-client text-end">
                              <div className="message-data-client">
                                <span className="message-data-client-time">
                                  {data.senderName} &nbsp;
                                  <img
                                    src="/img/user.png"
                                    className="img-fluid"
                                    alt=""
                                  />
                                </span>
                              </div>
                              <div
                                className="message-client other-message-client"
                                style={{ backgroundColor: "#DEFFDE" }}
                              >
                                {data.message ? <>{data.message}</> : <></>}
                                {data.files.length !== 0 ? (
                                  <>
                                    {data.files[0].fileName
                                      .split(".")
                                      .pop()
                                      .toLowerCase() === "png" ||
                                    data.files[0].fileName
                                      .split(".")
                                      .pop()
                                      .toLowerCase() === "jpg" ||
                                    data.files[0].fileName
                                      .split(".")
                                      .pop()
                                      .toLowerCase() === "jpeg" ? (
                                      <>
                                        {" "}
                                        <img
                                          className=""
                                          style={{
                                            width: "100%",
                                            height: "250px",
                                          }}
                                          src={data.files[0].fileUrl}
                                          alt=""
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <i className="bi bi-file-pdf-fill text-white" />
                                        &nbsp;
                                        {data.files[0].fileName}
                                      </>
                                    )}

                                    <br />
                                    <a
                                      target="_blank"
                                      href={data.files[0].fileUrl}
                                      download={data.files[0].fileUrl}
                                    >
                                      Download
                                    </a>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="message-data-client">
                                <span className="message-data-client-time">
                                  {format(
                                    new Date(data.createdAt),
                                    "dd MMM, yyyy hh:mm a"
                                  )}
                                </span>
                              </div>
                            </li>
                          ) : (
                            <li className="clearfix-client">
                              <div className="message-data-client">
                              <span className="message-data-client-time">
                              <img
                                src="/img/user.png"
                                className="img-fluid"
                                alt=""
                              />
                              &nbsp; {selectedChatName}
                            </span>
                              </div>

                              <div
                                className="message-client my-message-client"
                                style={{ backgroundColor: "#DEF0FF" }}
                              >
                                {data.message ? <>{data.message}</> : <></>}
                                {data.files.length !== 0 ? (
                                  <>
                                    {data.files[0].fileName
                                      .split(".")
                                      .pop()
                                      .toLowerCase() === "png" ||
                                    data.files[0].fileName
                                      .split(".")
                                      .pop()
                                      .toLowerCase() === "jpg" ||
                                    data.files[0].fileName
                                      .split(".")
                                      .pop()
                                      .toLowerCase() === "jpeg" ? (
                                      <>
                                        {" "}
                                        <img
                                          className=""
                                          style={{
                                            width: "100%",
                                            height: "250px",
                                          }}
                                          src={data.files[0].fileUrl}
                                          alt=""
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <i className="bi bi-file-pdf-fill text-danger" />
                                        &nbsp;
                                        {data.files[0].fileName}
                                      </>
                                    )}

                                    <br />
                                    <a
                                      target="_blank"
                                      href={data.files[0].fileUrl}
                                      download={data.files[0].fileUrl}
                                    >
                                      Download
                                    </a>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="message-data-client">
                                <span className="message-data-client-time">
                                  {format(
                                    new Date(data.createdAt),
                                    "dd MMM, yyyy hh:mm a"
                                  )}
                                </span>
                              </div>
                            </li>
                          )
                        )}
                    </>
                  </ul>
                  {showPicker && (
                    <div
                    onClick={(e) => e.stopPropagation()}
                      className="float-right"
                      style={{
                        zIndex: "7",
                        position: "absolute",
                        right: "10px",
                        bottom: "350px",
                      }}
                    >
                      <Picker
                        pickerStyle={{ width: "100%", opacity: "0.1" }}
                        onEmojiClick={onEmojiClick}
                      />
                    </div>
                  )}
                </div>
                {selectedChatName == "" ? (
                  <></>
                ) : (
                  <div className="chat-message-client clearfix-client">
                    <div className="input-group chat-input-group mb-0">
                      <div  className="input-group-prepend">
                        <span
                       onClick={(e) => e.stopPropagation()}    
                          className="input-group-text h-100 chat-input-ctas"
                        >
                          <i class="bi bi-emoji-smile" onClick={() => setShowPicker((val) => !val)} role="button"></i>
                        </span>
                      </div>
                      <div  className="input-group-prepend">
                        <span
                          
                          className="input-group-text h-100 chat-input-ctas"
                        >
                          <i class="bi bi-file-earmark-arrow-up" onClick={handleAttachFile} role="button"></i>
                        </span>
                        <input
                          ref={fileRef}
                          type="file"
                          onChange={handleImageChange}
                          className="form-control-file d-none"
                          id="exampleFormControlFile1"
                        />
                      </div>

                      <input
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSend();
                          }
                        }}
                        id="client-message-input"
                        type="text"
                        className="chat-input-field"
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Enter text here..."
                        value={message}
                      />
                      {loading === true ? (
                        <></>
                      ) : (
                        <>
                          <div  className="input-group-prepend">
                            <span
                              
                              className="input-group-text h-100 chat-input-ctas"
                            >
                              <i class="bi bi-send" onClick={handleSend} role="button"></i>
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
              <img
                src="/img/leadership-empty.svg"
                className="img-fluid"
                alt=""
              />
              <h2 className="leadership-empty-heading">It’s Empty here!</h2>
              <p className="leadership-empty-para mt-2">
                Look’s like you haven’t any chat.
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default ShowingChat;
